import {
  EstablishPettyCashStateTypes,
  EstablishPettyCashActionTypes,
} from "./EstablishPettyCash.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: EstablishPettyCashStateTypes = {
  fetchAll: resetApiCallState([]),
  fetchOne: resetApiCallState({}),
};

const EstablishPettyCashReducer = (
  state: EstablishPettyCashStateTypes = INITIAL_STATE,
  action: any
): EstablishPettyCashStateTypes => {
  switch (action.type) {
    case EstablishPettyCashActionTypes.FETCH_ALL_ESTABLISH_PETTY_CASH:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case EstablishPettyCashActionTypes.FETCH_ALL_ESTABLISH_PETTY_CASH_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case EstablishPettyCashActionTypes.FETCH_ALL_ESTABLISH_PETTY_CASH_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case EstablishPettyCashActionTypes.FETCH_ALL_ESTABLISH_PETTY_CASH_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    case EstablishPettyCashActionTypes.FETCH_ONE_ESTABLISH_PETTY_CASH:
      return {
        ...state,
        fetchOne: {
          error: null,
          payload: {},
          isPending: true,
          isSuccessful: false,
        },
      };
    case EstablishPettyCashActionTypes.FETCH_ONE_ESTABLISH_PETTY_CASH_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case EstablishPettyCashActionTypes.FETCH_ONE_ESTABLISH_PETTY_CASH_FAILURE:
      return {
        ...state,
        fetchOne: {
          payload: {},
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case EstablishPettyCashActionTypes.FETCH_ONE_ESTABLISH_PETTY_CASH_SUCCESS:
      return {
        ...state,
        fetchOne: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default EstablishPettyCashReducer;
